import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"
import { Tooltip } from "antd"
import configure from "configure"
import ZithasLogo from "../../../assets/images/main-zithas.png"
import { getInitials } from "utils/common-helpers"

export const WorkLoadReportColumn = () => [
  {
    Header: () => <div className="text-center">User</div>,
    accessor: "user",
    Cell: ({ row }) => {
      const { alias_name, avatar } = row.original.users || {}
      return (
        <div
          className="d-flex align-items-center justify-content-center gap-1"
          style={{ whiteSpace: "nowrap" }}
        >
          {/* <Tooltip color="#752b97" title={alias_name || "-"}>
            <img
              src={`${avatar != null ? `${configure.imgUrl}${avatar}` : ZithasLogo}`}
              alt="Profile"
              className="rounded-circle"
              width="24"
              height="24"
            />
          </Tooltip> */}
          {avatar ? ( 
          <Tooltip color="#752b97" title={alias_name || "-"}>
            <img
              src={`${avatar != null ? `${configure.imgUrl}${avatar}` : ZithasLogo}`}
              alt="Profile"
              className="rounded-circle"
              width="24"
              height="24"
            />
          </Tooltip>
          ) : (
            <div className="defualt-img" title={alias_name || "-"}>
              {getInitials(alias_name || "Z")}
            </div>
          )}
        </div>
      )
    },
    style: { width: "80px", maxWidth: "80px" },
  },
  {
    Header: <div className="text-center">No. of Projects</div>,
    accessor: "projectCounts",
    Cell: ({ row }) => (
      <span className="d-flex flex-column align-items-center">
        {row.original.projectCounts}
      </span>
    ),
    style: { width: "80px", maxWidth: "80px" },
  },
  {
    Header: <div className="text-center">No. of Task</div>,
    accessor: "taskCounts",
    Cell: ({ row }) => (
      <span className="d-flex flex-column align-items-center">
        {row.original.taskCounts}
      </span>
    ),
    style: { width: "80px", maxWidth: "80px" },
  },
  {
    Header: "Allocated Time",
    accessor: "totalEstimatedTime",
    Cell: ({ row }) => (
      <div className="d-flex flex-column align-items-center">
        {row.original.totalEstimatedTime}
      </div>
    ),
    style: { width: "100px", maxWidth: "100px" },
  },
  {
    Header: "Used Hours",
    accessor: "totalActualTime",
    Cell: ({ row }) => (
      <div className="d-flex flex-column align-items-center">
        {row.original.totalActualTime}
      </div>
    ),
    style: { width: "100px", maxWidth: "100px" },
  },
  {
    Header: "InOffice Hours",
    accessor:"totalInOfficeTime",
    id: "totalInOfficeTime",
    Cell: ({ row }) => {
      return (
        <div className="d-flex flex-column align-items-center">
          {row.original.totalInOfficeTime || "00:00:00"}
        </div>
      );
    }
  },
  {
    Header: "Productivity Difference",
    accessor:"productivityTime",
    id: "productivityTime",
    Cell: ({ row }) => (
      <div className="d-flex flex-column align-items-center">
        {row.original.productivityTime || "00:00:00"}
      </div>
    ),
    style: { width: "120px", maxWidth: "120px" },
  },
  {
    Header: "Used Amount/ Amount Paid",
    accessor:"paidAmount",
    id: "amountSummary",
    Cell: ({ row }) => {
      const { amountSpent, paidAmount } = row.original
      return (
        <div className="d-flex flex-column align-items-center">
          {amountSpent} / {paidAmount}
        </div>
      )
    },
    style: { width: "120px", maxWidth: "120px" },
  },
  {
    Header: "Action",
    accessor: "subject",
    className: "text-center  col-md-1",
    Cell: cellProps => {
      const obj = cellProps?.row?.original
      return (
        <div className="d-flex align-items-center justify-content-center gap-1">
          <a
            className="btn btn-sm btn-outline-success me-1 "
            title="Punch Logs"
          >
            <i className="fas fa-business-time"></i>
          </a>
        </div>
      )
    },
  },
]